package de.oevbs.kunde.kundenportal2.model.services.mydata

import de.oevbs.businesspartner.bpcrmservice2.partner.model.*
import de.oevbs.kunde.kundenportal2.validation.Regexes
import de.oevbs.kunde.kundenportal2.validation.validateUsingRegex
import de.oevbs.sfa.data.REGEX_EMAIL
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.Severity
import dev.fritz2.validation.Validation
import dev.fritz2.validation.validation
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.serialization.Serializable

private val instant: Instant = Clock.System.now()
private val year: Int = instant.toString().subSequence(0, 4).toString().toInt()
private val month: Int = instant.toString().subSequence(5, 7).toString().toInt()
private val day: Int = instant.toString().subSequence(8, 10).toString().toInt()
val defaultBirthday = LocalDate(year, month, day)

@Lenses
@Serializable
data class ContactInformation(
    val salutation: Salutation = Salutation.Frau,
    val title: AcademicTitle = AcademicTitle.Unbekannt,
    val firstName: String = "", // nicht editierbar
    val namePrefix: NamePrefix = NamePrefix.Unbekannt,
    val lastName: String = "",
    val dateOfBirth: LocalDate = defaultBirthday, // nicht editierbar
    val address: Address = Address(), // Initiale Werte aus den CRM Partnerdaten und Input
    val addressSuggestion: Address = Address(), // Rückgabe des CRM nach Adresscheck
    val forceUseUserInputAddress: Boolean = false, // false: Backend prüft Adresse und schlägt was vor. true: Backend verwendet address, egal was damit ist
    val phone: String = "",
    val mobile: String = "",
    val mail: String = "",
    val mailConfirm: String = "", // enthält nur Daten, wenn der User seine Mail ändern will
) {
    companion object {

        val validation: Validation<ContactInformation, Boolean, ComponentValidationMessage> =
            validation { inspector, mailWasEdited ->

                val lastname = inspector.map(ContactInformation.lastName())
                addAll(lastname.validateUsingRegex(Regexes.name))

                val addressSub = inspector.map(ContactInformation.address())

                val streetSub = addressSub.map(Address.street())
                addAll(streetSub.validateUsingRegex(Regexes.name))

                val streetNoSub = addressSub.map(Address.houseNumber())
                addAll(streetNoSub.validateUsingRegex(Regexes.streetNumber))

                val postalCodeSub = addressSub.map(Address.postalCode())
                addAll(postalCodeSub.validateUsingRegex(Regexes.postalCode))

                val citySub = addressSub.map(Address.city())
                addAll(citySub.validateUsingRegex(Regexes.name))

                val phoneSub = inspector.map(ContactInformation.phone())
                addAll(
                    phoneSub.validateUsingRegex(
                        Regexes.phoneNumber,
                        allowEmptyInput = true
                    )
                )

                val mobileSub = inspector.map(ContactInformation.mobile())
                addAll(
                    mobileSub.validateUsingRegex(
                        Regexes.phoneNumber,
                        allowEmptyInput = true
                    )
                )

                if (mobileSub.data.isNotBlank() && phoneSub.data.isNotBlank()) {
                    if (mobileSub.data.filter { it.isDigit() } == phoneSub.data.filter { it.isDigit() }) {
                        add(
                            ComponentValidationMessage(
                                path = mobileSub.path,
                                severity = Severity.Error,
                                message = "Die Telefonnummern müssen sich unterscheiden."
                            )
                        )
                        add(
                            ComponentValidationMessage(
                                path = phoneSub.path,
                                severity = Severity.Error,
                                message = "Die Telefonnummern müssen sich unterscheiden."
                            )
                        )
                    }
                }

                val mailSub = inspector.map(ContactInformation.mail())
                addAll(mailSub.validateUsingRegex(REGEX_EMAIL.toRegex()))

                if (mailWasEdited) {
                    val mailConfirm = inspector.map(ContactInformation.mailConfirm())
                    if (mailConfirm.data.isEmpty()) {
                        add(ComponentValidationMessage(
                            path = mailConfirm.path,
                            severity = Severity.Error,
                            message = "Bitte wiederholen Sie Ihre Mail-Adresse."
                        ))
                    } else if (mailConfirm.data != mailSub.data) {
                        add(ComponentValidationMessage(
                            path = mailConfirm.path,
                            severity = Severity.Error,
                            message = "Die Mail-Adressen stimmen nicht überein."
                        ))
                    }
                }
            }
    }
}